<template>
	<div>
		<div v-if="bitsCreditAmount > 0" class="credit-bar text-center secondary">
			<h4 class="fs--11 white--text">Channel Sticker Credit: {{ bitsCreditAmount }} Bits</h4>
		</div>
		<div class="panel-header d-flex align-center justify-center">
			<div class="header-text text-center">
				<h4 class="fs--14" v-html="panelTitle"></h4>
			</div>
			<!-- show when extension is disconnected from server -->
			<img
				v-if="!isExtensionOnline"
				:class="bitsCreditAmount > 0 ? 'top-18' : 'disconnected'"
				src="@/assets/icons/connection.png"
				alt="Disconnected" />
		</div>
	</div>
</template>

<script>
import { useStore } from '@/store';
import { computed } from 'vue';
export default {
	name: 'PanelHeader',
	setup() {
		const store = useStore();
		const isExtensionOnline = computed(() => {
			return store.state.isExtensionOnline;
		});

		const panelTitle = computed(() => {
			return store.state.localization.panelTitle;
		});

		const bitsCreditAmount = computed(() => {
			return store.state.bitsCreditAmount;
		});

		return { isExtensionOnline, bitsCreditAmount, panelTitle };
	},
};
</script>

<style scoped>
img.disconnected {
	position: absolute;
	right: 0;
	top: 2px;
}

img.top-18 {
	position: absolute;
	right: 0;
	top: 18px;
}
</style>
